export default "__VITE_PUBLIC_ASSET__30452772__"